if (!customElements.get('product-upsell-bundle')) {
  customElements.define(
    'product-upsell-bundle',
    class ProductUpsellBundle extends HTMLElement {
      connectedCallback() {
        this.checkboxes = [...this.querySelectorAll('[data-upsell-selection]')];
        this.button = this.querySelector('[data-upsell-bundle-add]');
        this.error = this.querySelector('[data-upsell-error]');
        this.mainForm = document.getElementById(this.dataset.productFormId);
        this.mainVariantInput = this.mainForm?.querySelector('[name="id"]');
        this.variants = JSON.parse(this.querySelector('[data-upsell-main-variants]')?.textContent || '[]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', () => this.updateSummary());
          checkbox.closest('.product-upsell__check')?.addEventListener('click', (event) => {
            event.preventDefault();
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        this.mainVariantInput?.addEventListener('change', () => this.updateSummary());
        this.button?.addEventListener('click', () => this.addBundle());
        this.updateSummary();
      }

      get mainVariant() {
        return this.variants.find((variant) => String(variant.id) === String(this.mainVariantInput?.value)) || this.variants[0];
      }

      updateSummary() {
        const selected = this.checkboxes.filter((checkbox) => checkbox.checked);
        const total = selected.reduce((sum, checkbox) => sum + Number(checkbox.closest('[data-price]')?.dataset.price || 0), Number(this.mainVariant?.price || 0));
        this.querySelector('[data-upsell-count]').textContent = String(selected.length + 1);
        this.querySelector('[data-upsell-total]').textContent = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: this.dataset.currency || 'JPY', maximumFractionDigits: 0 }).format(total / 100);
      }

      async addBundle() {
        if (!this.mainVariant?.id || this.button.getAttribute('aria-disabled') === 'true') return;
        this.setLoading(true);
        this.showError('');

        try {
          await window.SocialGiftCartGuard?.clearGiftCart();
          const items = [
            { id: Number(this.mainVariant.id), quantity: 1 },
            ...this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => ({ id: Number(checkbox.value), quantity: 1 })),
          ];
          const body = { items };
          if (this.cart) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'カートに追加できませんでした。');

          if (this.cart) {
            this.cart.classList.remove('is-empty');
            this.cart.renderContents(result);
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          this.showError(error.message || 'カートに追加できませんでした。時間をおいてもう一度お試しください。');
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(loading) {
        this.button.toggleAttribute('aria-disabled', loading);
        this.button.classList.toggle('loading', loading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }
    }
  );
}
